import { useAlert } from 'components/alert'
import { useSession } from 'components/auth/useSession'
import { usePecField } from 'components/form/final-form/hooks/useField'
import { useParams } from 'react-router'
import { metaPath } from 'util/metaPath'
import { SoapState } from 'view/atendimentos/atendimento-individual/model'

import { SolicitacaoExameModel } from '../../../model-solicitacaoExames'
import { RequisicaoExameModal, RequisicaoExameModalStep } from '../RequisicaoExameModal'
import { MamografiaIndicacaoClinicaModalStep } from './indicacao-clinica/MamografiaIndicacaoClinicaModalStep'
import { MamografiaAnamneseModalStep } from './MamografiaAnamneseModalStep'
import { MamografiaDadosExameModalStep } from './MamografiaDadosExameModalStep'
import { MamografiaPerguntaField, RequisicaoExameMamografiaFormValues } from './model-mamografia'
import {
  mamografiaAnamneseValidator,
  mamografiaDadosExameValidator,
  mamografiaIndicacaoClinicaValidator,
} from './validator-mamografia'

interface RequisicaoExameMamografiaModalProps {
  onClose: () => void
  handleUpdate: (model: SolicitacaoExameModel) => void
}

const soapPath = metaPath<SoapState>()

const steps: RequisicaoExameModalStep<RequisicaoExameMamografiaFormValues>[] = [
  { title: 'Anamnese', render: () => <MamografiaAnamneseModalStep />, validator: mamografiaAnamneseValidator },
  {
    title: 'Indicação clínica',
    render: () => <MamografiaIndicacaoClinicaModalStep />,
    validator: mamografiaIndicacaoClinicaValidator,
  },
  {
    title: 'Dados do exame',
    render: () => <MamografiaDadosExameModalStep />,
    validator: mamografiaDadosExameValidator,
  },
]

export function RequisicaoExameMamografiaModal(props: Readonly<RequisicaoExameMamografiaModalProps>) {
  const { onClose, handleUpdate } = props
  const alert = useAlert()
  const { id } = useParams<{ id: string }>()

  const { data: session } = useSession()

  const profissional = session?.profissional

  const {
    input: { value: adicionados },
  } = usePecField<ReadonlyArray<SolicitacaoExameModel>>({
    name: soapPath.plano.solicitacoesExame,
    subscription: { value: true },
  })

  const solicitacao = adicionados?.find((item: SolicitacaoExameModel) => item._id === id)

  const handleSubmit = (values: RequisicaoExameMamografiaFormValues) => {
    if (solicitacao) {
      handleUpdate({
        ...solicitacao,
        rastreioMamografia: values,
      })
    }
    alert('success', 'Requisição de exame de mamografia salva com sucesso')
    onClose()
  }

  const initialValues = {
    [MamografiaPerguntaField.nomeResponsavel]: profissional?.nome ?? undefined,
    [MamografiaPerguntaField.cns]: profissional?.cns ?? undefined,
    [MamografiaPerguntaField.numeroConselho]: profissional?.numeroConselhoClasse ?? undefined,
    [MamografiaPerguntaField.siglaNomeConselho]: profissional?.conselhoClasse?.sigla ?? undefined,
    ...solicitacao?.rastreioMamografia,
  }

  return (
    <RequisicaoExameModal<RequisicaoExameMamografiaFormValues>
      title='Requisição de exame de mamografia'
      steps={steps}
      onSubmit={handleSubmit}
      onClose={onClose}
      initialValues={initialValues}
    />
  )
}
